import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Form from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import asyncAction from 'modules/core/lib/asyncAction'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import i18n from 'modules/core/lib/i18n'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import CompanyRepresentativeForm from 'modules/settings/lib/forms/Representative'

interface Props {
  legalEntity: LegalEntity
}

const Representative: React.FC<Props> = ({ legalEntity }: Props) => {
  const { has_payroll: hasPayroll } = useFeatures(['payroll'])
  const companyRepresentativeForm = new CompanyRepresentativeForm(legalEntity.toJS())

  const onSubmitRepresentative = () => {
    return asyncAction(() => companyRepresentativeForm.save(legalEntity))
  }

  return (
    <PanesPadForm direction="horizontal" boxed>
      <PanesHeader
        illustration="user-tie"
        title={i18n.t('settings.edit_company.representative_form.title')}
        description={i18n.t('settings.edit_company.representative_form.description')}
      />
      <Form onSubmit={onSubmitRepresentative}>
        <FormRow>
          <Text
            label={i18n.t('settings.edit_company.representative_form.fields.name')}
            field={companyRepresentativeForm.get('representative_name')}
            mandatory={hasPayroll}
          />
        </FormRow>
        <FormRow multi>
          <Text
            label={i18n.t('settings.edit_company.representative_form.fields.first_surname')}
            field={companyRepresentativeForm.get('representative_first_surname')}
            mandatory={hasPayroll}
          />
          <Text
            label={i18n.t('settings.edit_company.representative_form.fields.second_surname')}
            field={companyRepresentativeForm.get('representative_second_surname')}
            mandatory={hasPayroll}
          />
        </FormRow>
        <FormRow>
          <Text
            label={i18n.t('settings.edit_company.representative_form.fields.identifier')}
            field={companyRepresentativeForm.get('representative_identifier')}
            mandatory={hasPayroll}
          />
        </FormRow>
        <FormRow>
          <Text
            label={i18n.t('settings.edit_company.representative_form.fields.job_title')}
            field={companyRepresentativeForm.get('representative_job_title')}
            mandatory={hasPayroll}
          />
        </FormRow>
        {companyRepresentativeForm.isDirty && (
          <FormRow footer>
            <Button submit>{i18n.t('common.submit')}</Button>
          </FormRow>
        )}
      </Form>
    </PanesPadForm>
  )
}

export default observer(Representative)
